import React, { Fragment, useContext, useEffect } from "react";
import "react-virtualized/styles.css";
import { RulesContext } from "../../../RulesContext";
import { EmptyCircle, FilledCircle, HalfFilledCircle, OutlineCircle } from "assests/GmsIcons";
import { SELECT_ATTRIBUTE } from "../../RuleConstants";

const MatrixTable = () => {
  const { compatibilityData, setCompatibilityData, ruleDispatch, cellStates, setCellStates, paginationParams, selectedCategories, setPaginationParams, CBMOptions } = useContext(RulesContext);
  const {  leftCatListOption, rightCatListOption, leftCatProductList, rightCatProductList, leftAttributeValues, rightAttributeValues, rightAttributeValueName,  leftAttributeValueName, compatibilityLevel, leftValuesAttrName, rightValuesAttrName, isProductFilter } = CBMOptions;
  
  let moduloNo = compatibilityLevel === "level2" ? 2 : compatibilityLevel === "level3" ? 3 : 4;

  const rows = leftCatListOption === "values" ? leftAttributeValues : leftCatProductList;
  const columns = rightCatListOption === "values" ? rightAttributeValues : rightCatProductList;

  const handleCellClick = (row, column) => {
    const cellKey = `${row.id}-${column.id}`;

    setCellStates((prevStates) => {
      const currentCellState = prevStates[cellKey] || 0;
     
      const maxState = moduloNo - 1; // This gives us the "best" state
      const nextState = currentCellState === 0 ? maxState : 0; // Toggle between incompatible and best

      const newStates = { ...prevStates, [cellKey]: nextState };
      const compatibilityLevel = getCompatibilityLevel(nextState);

      setCompatibilityData((prevData) => {
        let existingIndex = -1; 
        if (leftCatListOption === 'values') {
          existingIndex = prevData.findIndex( (data) => data.leftValueId === row.id && data.rightValueId === column.id);
        } else {
          existingIndex = prevData.findIndex( (data) => data.leftProdId === row.id && data.rightProdId === column.id);
        }
        if (existingIndex !== -1) {
          prevData[existingIndex].compatibility = compatibilityLevel;
        } else {
          if (leftCatListOption === 'values') {
            prevData.push({ compatibility: compatibilityLevel, leftValueId: row.id, rightValueId: column.id, });
          } else {
            prevData.push({ compatibility: compatibilityLevel, leftProdId: row.id, rightProdId: column.id, });
          }
        }
        return [...prevData];
      });
      return newStates;
    });
  };

  useEffect(() => {
    if (compatibilityData.length !== 0) {
      const removedIncompatibleItems = compatibilityData.filter(item => item.compatibility !== "incompatible");
      ruleDispatch({ type: "CBM_RULE_TYPE", data: removedIncompatibleItems });
    }
  }, [compatibilityData]);
  
  const getCompatibilityLevel = (state) => {
    switch (state) {
      case 0:
        return 'incompatible';
      case 1:
      case 2:
      case 3:
        return 'best'; 
      default:
        return 'incompatible';
    }
  };

  const renderCellImage = (row, column) => {
    const cellKey = `${row.id}-${column.id}`;
    const cellState = cellStates[cellKey] || 0;

    // Only show EmptyCircle for incompatible (0) and FilledCircle for best (non-zero)
    return cellState === 0 ? <EmptyCircle /> : <FilledCircle />;
  };

  // const handlePageChange = (pageNumber) => {
  //   setPaginationParams((prevState) => ({
  //       ...prevState,
  //       pageNumber: pageNumber,
  //   }));
  //   }
  
    const updatePageSize = (pageSize) => {
      setPaginationParams((prevState) => ({
          ...prevState,
          pageSize: pageSize,
      }));
  };

  //const totalPages = () => Math.max(totalRecords.leftAttributeValues, totalRecords.rightAttributeValues);

  return (
    <Fragment>
      {rows?.length !==0 && columns?.length !== 0 ? <label className="tw-flex tw-bg-zinc-100 tw-py-3 tw-justify-center tw-text-xs">
      {leftCatListOption === "values" ? `${selectedCategories?.rightCategory?.name}/${leftCatListOption}${rightValuesAttrName ? '/': ''}${rightValuesAttrName ?? ''}` : null}
      {leftCatListOption === "products" ? isProductFilter ? `${selectedCategories?.rightCategory?.name}/${leftCatListOption}${(rightValuesAttrName !== "" && rightValuesAttrName !== "Select attributes") ? "/" + rightValuesAttrName  : ""}${rightAttributeValueName !== "" ? "/" + rightAttributeValueName : ""}` : `${selectedCategories?.rightCategory?.name}/${leftCatListOption}` : null}
      </label> : null}
      <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-[600px]">
        {rows?.length !==0 && columns?.length !== 0 ?
          <div className="tw-flex tw-flex-col tw-w-[2%] tw-bg-zinc-100 tw-h-full tw-items-center tw-justify-center tw-px-6">
            <label className="tw-text-center tw-text-xs tw-transform -tw-rotate-90">
              {rightCatListOption === "values" ? `${selectedCategories?.leftCategory?.name}/values${leftValuesAttrName ? '/' : ''}${leftValuesAttrName ?? ''}` : null}
              {rightCatListOption === "products" ? isProductFilter ? `${selectedCategories?.leftCategory?.name}/${rightCatListOption}${(leftValuesAttrName !== '' && leftValuesAttrName !== SELECT_ATTRIBUTE) ? "/" + leftValuesAttrName : ""}${leftAttributeValueName !== "" ? "/" + leftAttributeValueName : "" }` : `${selectedCategories?.leftCategory?.name}/${rightCatListOption}` : null}
            </label>
          </div> : null}
        <div className="table-container tw-h-[600px] tw-w-[98%] tw-overflow-x-auto tw-overflow-y-auto" >
          {rows?.length !== 0 && columns?.length !== 0 ? (
            <div className="tw-overflow-x-auto">
              <table className="tw-table-auto tw-border tw-border-collapse tw-w-full">
                <thead className="tw-bg-[#F2F2F2] tw-whitespace-nowrap tw-sticky">
                  <tr className="tw-sticky">
                    <th className="tw-sticky tw-p-2 tw-text-[#090A42] tw-text-sm tw-font-normal tw-max-w-[7rem] tw-truncate tw-left-0"></th>
                    {columns.map((column) => 
                      <th className="tw-border tw-w-auto tw-p-2 tw-text-[#090A42] tw-text-sm tw-font-normal tw-relative tw-max-w-[7rem] tw-truncate tw-text-center" title={ column.value} key={column.id}>
                        {column.value}
                      </th>)}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr className="tw-border tw-w-auto" key={row.id + index}>
                      <td className="tw-p-2 tw-bg-[#F2F2F2] tw-border tw-w-auto tw-text-[#090A42] tw-text-sm tw-font-normal tw-max-w-[7rem] tw-truncate tw-text-start tw-sticky tw-left-0" title={ row?.value ?? ''}>{ row?.value ?? ''}</td>
                      {columns.map((column) => (
                        <td className="tw-select-none tw-border tw-bg-white" key={column.id}>
                          <label className="tw-flex tw-items-center tw-justify-center">
                            <span onClick={() => handleCellClick(row, column)}>{renderCellImage(row, column)}</span>
                          </label>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>  
              </table>
            </div>
          ) : null}
        </div>
      </div> 
      {rows?.length !==0 || columns?.length !== 0 ? <div className="tw-py-2">
            <div className={`tw-flex tw-justify-end tw-items-center tw-space-x-3 tw-flex-wrap`}>
              <div className={`tw-flex tw-items-center tw-space-x-3`}>
                  <span>Show</span>
                  <select className={`tw-border focus:tw-outline-none tw-p-1`} style={{ width: "80px" }} aria-label="Records on page select" value={paginationParams?.pageSize ?? 20} onChange={(e) => { updatePageSize(parseInt(e?.target?.value)); }} >
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                    <option value={500}>500</option>
                  </select>
              </div>
              {/* <Paginator onPageChange={handlePageChange} recordPerPage={paginationParams?.pageSize} presentPage={paginationParams?.pageNumber} totalRecords={totalPages()} /> */}
              </div></div> : null}
    </Fragment>
  );
};

export default React.memo(MatrixTable);